import type { PageContext } from "vike/types";
import type { Translatable } from "@/types";
export default function (context: PageContext) {
  //TODO this shouldn't be null or undefined.
  return (item: Translatable | null | undefined) => {
    if (!item) return "translate test";
    if (typeof item === "string") item = context.translations[item] || item;
    if (typeof item === "string") return item;
    const language =
      globalThis.window?.navigator.language.split("-")[0] ?? "en";
    return item[language] || item.en;
  };
}
